import Link from 'next/link'

import { IEmployee, IEmployeeReduced, TEAM_CATEGORY_TYPE_ENUM } from '@/_types'

export default function ATeamMemberCardButtons({
	employee,
	reservationButton,
	orderUrl = '/volne-terminy',
	handleShowDetail
}: {
	employee: IEmployee | IEmployeeReduced
	reservationButton: boolean
	handleShowDetail: (e: React.MouseEvent<HTMLAnchorElement>) => void
	orderUrl?: string
}) {
	return (
		<div className='employee__buttons flex flex-col gap-1 items-center justify-end h-full'>
			{employee.categories?.some(
				category => category.type === TEAM_CATEGORY_TYPE_ENUM.MEDICAL_PERSONNEL
			) &&
				reservationButton && (
					<Link
						href={orderUrl}
						prefetch={false}
						className='btn_basic type4 mb-2 w-fit'
						onClick={e => e.stopPropagation()}
					>
						{/* <span className='short'>Rezervovať</span> */}
						{/* <span className='long hidden'>Rezervovať termín</span> */}
						<span>Objednať sa online</span>
						<span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r' />
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar2_r' />
								</svg>
							</span>
						</span>
					</Link>
				)}

			<Link
				href={`/tim/${employee.slug}`}
				prefetch={false}
				className='btn_basic type11 w-fit'
				onClick={handleShowDetail}
			>
				<span>Zobraziť profil</span>
				<span>
					<span>
						<svg className='sico'>
							<use href='/assets/layout/icons.svg#s_ar2_r' />
						</svg>
					</span>
					<span>
						<svg className='sico'>
							<use href='/assets/layout/icons.svg#s_ar2_r' />
						</svg>
					</span>
				</span>
			</Link>
		</div>
	)
}
